import deviceDetector from 'mobile-device-detect'
import { auth, analytics } from '../Firebase'

export function logEvent(eventName) {
  const payload = {
    user: auth.currentUser.email,
    browserName: deviceDetector.browserName,
    browserVersion: deviceDetector.browserVersion
  }
  analytics.logEvent(eventName, payload)
}

export function logRouteEvent(route) {
  const payload = {
    user: auth.currentUser ? auth.currentUser.email : '',
    browserName: deviceDetector.browserName,
    browserVersion: deviceDetector.browserVersion,
    route: route
  }
  analytics.logEvent('open_route', payload)
}
